import { Children } from 'react'
import * as React from 'react'

type Props = React.PropsWithChildren<{}>

/**
 * Only renders the first non-empty child
 */
function OnlyOne({ children }: Props) {
  return <>{Children.toArray(children)[0]}</>
}

export default OnlyOne
